exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-popup-parent--hidden .fixed-header{padding-right:15px}", ""]);

// exports
